import { render } from "./Preload.vue?vue&type=template&id=39a15a92&scoped=true"
import script from "./Preload.vue?vue&type=script&lang=ts"
export * from "./Preload.vue?vue&type=script&lang=ts"

import "./Preload.vue?vue&type=style&index=0&id=39a15a92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39a15a92"

export default script